export default __webpack_public_path__ + "static/media/sharegate-wordmark.7474124c.svg";